import { DeviceTypesEnum } from "../../common/enums/DeviceTypesEnum";
import { PageConfigurationTypeEnum } from "../../services/page-configuration-service/Models";

export const keys = {
    all: ["page-configurations"],

    configuration: (groupID: number, configurationID: number, pageConfigurationType: PageConfigurationTypeEnum) => [
        ...keys.all,
        "configuration", {
            groupID,
            configurationID,
            pageConfigurationType
        }
    ],
    configurationList: (groupID: number, pageConfigurationType: PageConfigurationTypeEnum) => [
        ...keys.all,
        "configuration-list", {
            groupID,
            pageConfigurationType
        }
    ],
    configurationItems: (groupID: number, pageConfigurationType: PageConfigurationTypeEnum, deviceType?: DeviceTypesEnum) => [
        ...keys.all,        
        "configuration-items",
        {
            groupID,
            pageConfigurationType,
            deviceType
        }
    ],
    allConfigurations: (groupID: number, pageConfigurationType: PageConfigurationTypeEnum) => [
        ...keys.all,
        "all-configurations", {
            groupID,
            pageConfigurationType
        }
    ],


};
